<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
   import moment from 'moment';
    
   export default {
      page: {
         title: "Add Bookings",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {

         const current_date = moment().format("YYYY-MM-DD");
        
         return {
            title: "Add Bookings",
            items: [
               {
                  text: "Add Booking",
                  href: "/pharmacies",
               },
               {
                  text: "Add Booking",
                  active: true,
               },        
            ],

            booking: {
               booking_date: current_date,
               patient_id: '',
               pharmacy_id: '',
               booking_for:'',
            },
            pharmacies: [],
            patients: [],
            image: "",
            preview_image: "",
            countries: [],
            clinics: [],

            patient_visible: false,
            patient_keyword: '',
            patient_id: '',
            selected_patient_name: '',

            members: [],
            member_visible: false,
            member_keyword: '',
            member_id: '',

            pharmacy_location: '',
            pharmacy_marker: { position: { lat: null, lng: null } },
            pharmacy_center: { lat: null, lng: null },
            pharmacy_current_place: null,

            pharmacy_mapOptions: {
               disableDefaultUI: true,
            },

            loading: false,
            errors: {},
         };
      },
        mounted() {
          this.fetchCountryCodes();
          this.fetchPharmacies();
       },

      methods: {
        
        onClickOutside() {
            if(!this.patient_id){
                this.patient_keyword = '';
                this.patient_visible = false;
            }
        
        },
        closePatientSearch() {
            this.patient_visible = false;
            this.patient_keyword = '';
            this.patient_id = '';
         },

        fetchPatients() { 
            let url = "api/admin/pharmacy/orders/getpatients?keyword=" + this.patient_keyword;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.patients = responseData.patients;
                  if (this.$route.params.id) {
                     this.setPatient();
                  }else{
                     this.patient_visible = true;
                     this.justOpened = true;

                     // Focus the input after DOM update
                     this.$nextTick(() => {
                        this.$refs.patientInput?.focus();
                     });

                     // Reset the outside click block after a short delay
                     setTimeout(() => {
                        this.justOpened = false;
                     }, 300);
                  }
               })
               .catch((err) => console.log(err));
            
         },


         setPatient() {
            if (this.$route.params.id) {
               this.patient_id = this.$route.params.id;
               this.patient_keyword = this.$route.params.name;
               this.patient_visible = false;
            } else {
               // Get selected patient details
               const selectedPatient = this.patients.find(p => p.patient_id == this.patient_id);
               if (selectedPatient) {
                  this.patient_keyword = `${selectedPatient.country_code} ${selectedPatient.mobile} | ${selectedPatient.name}`;
                  this.selected_patient_name = selectedPatient.name;
               }
               this.patient_visible = false;
            }
            
            // Clear previous members and booking_for
            this.members = [];
            this.booking.booking_for = '';
            
            // Fetch members for selected patient
            if (this.patient_id) {
               this.fetchMembers();
            }
         },

         fetchMembers() {  
            let url = "api/admin/consultations/getMembers?patient_id=" + this.patient_id;         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.members = responseData.members;
                  this.member_visible = true;
                  
               })
               .catch((err) => console.log(err));
         },

         
         fetchCountryCodes() {
            let url = "api/admin/get-countries";         
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.countries = responseData.countries;
               })
               .catch((err) => console.log(err));
         },


         fetchPharmacies() {
            let url = "api/admin/pharmacy/getPharmacies";        
            this.getToken();
            this.$axios
               .get(url, { headers: { Authorization: "Bearer " + this.token } })
               .then((res) => {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.pharmacies = responseData.pharmacies || [];
               })
               .catch((err) => console.log(err));
         },
         
         numbersOnly(event) {
            let keyCode = event.keyCode;
            if (keyCode < 48 || keyCode > 57) {
               event.preventDefault();
            }
         }, 

         addBooking(){
            // Clear previous errors
            this.errors = {};
            
            // Validate required fields
            if (!this.patient_id) {
               this.errors.patient_id = ['Please select a patient'];
               return;
            }
            
            if (!this.booking.pharmacy_id) {
               this.errors.pharmacy_id = ['Please select a pharmacy'];
               return;
            }
            
            if (!this.booking.booking_date) {
               this.errors.booking_date = ['Please select a booking date'];
               return;
            }

            this.loading = true;
            this.getToken();

            const config = {
               headers: {
                  "Accept": "application/json",
                  "Authorization": "Bearer " + this.token,
               },
            };

            let url = "clinic/clinic/pharmacy/addBooking";

            let formData = new FormData();
            formData.append("pharmacy_id", this.booking.pharmacy_id);
            formData.append("patient_id", this.patient_id);
            formData.append("member_id", this.booking.booking_for || '');
            formData.append("booking_date", this.booking.booking_date);

            this.$axios
               .post(url, formData, config)
               .then((response) => {
                  if (response.data.status === 'true' || response.data.status === true) {
                     this.$swal({
                        title: "Success!",
                        text: response.data.message || "Booking created successfully",
                        icon: "success",
                        confirmButtonText: "OK"
                                           }).then(() => {
                         this.$router.push({ 
                            name: 'pharmacies',
                         });
                      });
                  } else {
                     this.$swal("Error", response.data.message || "Failed to create booking", "error");
                  }
               })
               .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        if(error.response.status == 422){
                           this.$nextTick(() => {
                              const firstErrorField = document.querySelector('.is-invalid');
                              if (firstErrorField) {
                                 firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
                                 firstErrorField.focus();
                              }
                           });
                        }
                     } else {
                        this.$swal("Error", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("Error", "Network error. Please try again.", "error");
                  }
               })
               .finally(() => {
                  this.loading = false;
               });
         },

         
         getToken() {
            if (localStorage.getItem('medicino_clinic')) {
               var medicino_clinic =  JSON.parse(localStorage.getItem('medicino_clinic'));
               if(medicino_clinic.token) {
                  this.token = medicino_clinic.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
         },
         setFile(e) {
            this.image = e.target.files[0];
            this.preview_image = URL.createObjectURL(e.target.files[0]);
         },

         resetForm() {
            this.booking = {
               booking_date: moment().format("YYYY-MM-DD"),
               patient_id: '',
               pharmacy_id: '',
               booking_for:'',
            };
            this.patient_id = '';
            this.patient_keyword = '';
            this.selected_patient_name = '';
            this.members = [];
            this.errors = {};
            this.patient_visible = false;
         }, 
      }
   }
</script>

    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">

                  <!----- top button area starts---->
                  <div class="row mb-2">
                     <div class="col-12">
                                                 <router-link :to="{ name: 'pharmacies.bookings', params: { pharmacy_id: $route.params.pharmacy_id } }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->
                  <b-card header-class="bg-transparent border-light" class="border border-light">
                      <form class="form-horizontal" role="form" @submit.prevent="addBooking()">
                        
                           <div class="row">
                            <div class="form-group col-md-6" v-click-outside="onClickOutside">
                               <label>Patient <span class="text-danger">*</span></label>
                               <div class="search-select">
                                  <span class="search-close" v-if="patient_visible" @click="closePatientSearch"><i class="dripicons dripicons-cross"></i></span>
                                  <!-- <span class="search-close" v-if="patient_visible && Boolean(patients.length)" @click="closePatientSearch"><i class="dripicons dripicons-cross"></i></span> -->
                                         
                                  <b-form-input ref="patientInput" v-model="patient_keyword"   @keyup="fetchPatients" 
                                  @click="fetchPatients"  autocomplete="off" placeholder="Search here..." v-bind:class="{ 'is-invalid': Boolean(errors.patient_id) }"></b-form-input>
                                  
                                  <b-form-select class="form-control" v-if="patient_visible && Boolean(patients.length)" v-model="patient_id" :select-size="patients.length < 10 ? (patients.length <= 1 ? 2 : patients.length) : 10" @change="setPatient">
                                     <b-form-select-option v-for="patient in patients" :key="patient.patient_id" :value="patient.patient_id">{{patient.country_code}} {{patient.mobile}} | {{ patient.name }} </b-form-select-option>
                                  </b-form-select>

                                  <b-form-select class="form-control" v-if="patient_visible && !Boolean(patients.length)" v-model="patient_id" :select-size="2">                  
                                        <b-form-select-option :value="0" disabled>No data results...</b-form-select-option>
                                  </b-form-select>
                               </div>

                               <div v-for="(val, index) in errors.patient_id" :key="index" class="invalid-feedback">
                                  <p class="mb-0">{{ val }}</p>
                               </div>
                             </div>  
                             
                             <div class="form-group col-md-6">
                               <label>Booking For <span class="text-danger">*</span></label>
                               <select class="form-control" v-model="booking.booking_for" v-bind:class="{ 'is-invalid': Boolean(errors.consultation_for) }">
                                  <option value="">Self</option>
                                  <option :value="member.id" v-for="member in members" :key="member.id">{{member.name}}</option>
                               </select>
                               <div v-for="(val, index) in errors.consultation_for" :key="index" class="invalid-feedback">
                                  <p class="mb-0">{{ val }}</p>
                               </div>
                             </div>
                         </div>

                         <div class="row mt-3">
                            <div class="form-group col-md-6">
                               <label>Pharmacy <span class="text-danger">*</span></label>
                               <select class="form-control" v-model="booking.pharmacy_id" v-bind:class="{ 'is-invalid': Boolean(errors.pharmacy_id) }">
                                  <option value="">Select Pharmacy</option>
                                  <option :value="pharmacy.id" v-for="pharmacy in pharmacies" :key="pharmacy.id">{{pharmacy.name}}</option>
                               </select>
                               <div v-for="(val, index) in errors.pharmacy_id" :key="index" class="invalid-feedback">
                                  <p class="mb-0">{{ val }}</p>
                               </div>
                            </div>
                            
                            <div class="form-group col-md-6">
                               <label>Booking Date <span class="text-danger">*</span></label>
                               <input type="date" class="form-control" v-model="booking.booking_date" v-bind:class="{ 'is-invalid': Boolean(errors.booking_date) }">
                               <div v-for="(val, index) in errors.booking_date" :key="index" class="invalid-feedback">
                                  <p class="mb-0">{{ val }}</p>
                               </div>
                            </div>
                         </div>

                        <div class="row mt-3">
                           <div class="col-12">
                              <button class="btn btn-primary me-2" type="submit" :disabled="loading">
                                 <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                 {{ loading ? 'Saving...' : 'Save' }}
                              </button>
                              <button type="button" class="btn btn-secondary me-2" @click="resetForm" :disabled="loading">Reset</button>
                                                             <router-link :to="{ name: 'pharmacies.bookings', params: { pharmacy_id: $route.params.pharmacy_id } }" class="btn btn-light" :disabled="loading">Cancel</router-link>
                           </div>
                        </div>
                     </form>
                  </b-card>
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
